import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import { AuthProvider } from "@/context/AuthContext";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Volunteer from "@/pages/Volunteer";
import Videos from "@/pages/Videos";
import Events from "@/pages/Events";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import YouthVictory from "@/pages/YouthVictory";
import Veterans from "@/pages/Veterans";
import Partners from "@/pages/Partners";
import SleepoverEducation from "@/pages/SleepoverEducation";
import WaysToGive from "@/pages/WaysToGive";
import DonationsDashboard from "@/pages/DonationsDashboard";
import Activism from "@/pages/Activism";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboardContent from "@/pages/AdminDashboardContent";
import PoliceAppreciation from "@/pages/PoliceAppreciation";
import PeacePilot from "@/pages/PeacePilot";
import PeaceArchitectApplication from "@/pages/PeaceArchitectApplication";
import MentorApplication from "@/pages/MentorApplication";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed initial data on first load
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        // Ignore if already seeded
      }
    };
    seedData();
  }, []);

  return (
    <AuthProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/success" element={<DonateSuccess />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/events" element={<Events />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/youth-victory" element={<YouthVictory />} />
              <Route path="/veterans" element={<Veterans />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/sleepover" element={<SleepoverEducation />} />
              <Route path="/ways-to-give" element={<WaysToGive />} />
              <Route path="/admin/donations" element={<DonationsDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboardContent />} />
              <Route path="/activism" element={<Activism />} />
              <Route path="/police-appreciation" element={<PoliceAppreciation />} />
              <Route path="/peace-pilot" element={<PeacePilot />} />
              <Route path="/peace-architect-apply" element={<PeaceArchitectApplication />} />
              <Route path="/mentor-apply" element={<MentorApplication />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
